module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Avegno-Gordevio_2010-57de633a0e89c7d246a53e73c89b76d3.svg";